var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g, _g2, _g3, _path81, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiano(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 220,
    viewBox: "0 0 283 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.63 198.699V202.657H274.464V198.699H253.63Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 194.742V198.699H274.464V194.742H253.631Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 190.783V194.741H274.464V190.783H253.631Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 186.826V190.783H274.464V186.826H253.631Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 182.867V186.826H274.464V182.867H253.631Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 178.91V182.868H274.464V178.91H253.631Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 174.952V178.91H274.464V174.952H253.631Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 197.953V200.191H267.52V197.953H253.631Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 193.25V195.487H267.52V193.249L253.631 193.25Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 186.267V188.503H267.52V186.267H253.631Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 181.792V184.029H267.52V181.792H253.631Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.631 177.232V179.47H267.52V177.232H253.631Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 170.995V174.952H274.465V170.995H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 167.038V170.995H274.465V167.038H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 163.079V167.036H274.465V163.079H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 159.122V163.079H274.465V159.122H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 155.164V159.122H274.465V155.164H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 151.205V155.164L274.465 155.163V151.205H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 147.248V151.205H274.465V147.248H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 170.249V172.487H267.521V170.249H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 165.546V167.783H267.521V165.546H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 158.562V160.799H267.521V158.562H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 154.088V156.326H267.521V154.088H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 149.528V151.765H267.521V149.528H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 143.291V147.248H274.465V143.291H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 139.333V143.291H274.465V139.333H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 135.375V139.333H274.465V135.375H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 131.417V135.375H274.465V131.417H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 127.46V131.417H274.465V127.46L253.632 127.46Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 123.502V127.46H274.465V123.502H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 119.544V123.502H274.465V119.544L253.632 119.544Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 142.544V144.782H267.521V142.544H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 137.842V140.078H267.521V137.842H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 130.858V133.095H267.521V130.858H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 126.384V128.621H267.521V126.384H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 121.824V124.061H267.521V121.824H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 87.8823V91.8399H274.465V87.8821L253.632 87.8823Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 83.9245V87.8823H274.465V83.9245H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 79.9666V83.9242H274.465V79.9666H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 76.009V79.9666H274.465V76.0088L253.632 76.009Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 72.0513V76.009H274.465V72.0512L253.632 72.0513Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 68.0933V72.051L274.465 72.0509V68.0933H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 64.1356V68.0933H274.465V64.1355L253.632 64.1356Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 87.1364V89.3734H267.521V87.1364H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 82.4332V84.6701H267.521V82.4332H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 75.4498V77.6868L267.521 77.6867V75.4498H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 70.9755V73.2125H267.521V70.9755H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 66.4159V68.6528H267.521V66.4158L253.632 66.4159Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 32.474V36.4317L274.465 36.4316V32.474H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 28.5163V32.474H274.465V28.5162L253.632 28.5163Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 24.5587V28.5163H274.465V24.5585L253.632 24.5587Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 20.6009V24.5587H274.465V20.6009H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 16.6433V20.601H274.465V16.6433H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 12.6856V16.6434L274.465 16.6433V12.6856L253.632 12.6856Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 31.7285V33.9655L267.521 33.9654V31.7285H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 27.0249V29.262L267.521 29.2618V27.0249H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 20.0419V22.2788H267.521V20.0419H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 15.5676V17.8045H267.521V15.5675L253.632 15.5676Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 115.587V119.544H274.465V115.586L253.632 115.587Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 111.629V115.587H274.465V111.629H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 107.671V111.629H274.465V107.671H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 103.714V107.671H274.465V103.714H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 99.7559V103.714L274.465 103.714V99.7559H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 95.7982V99.7559H274.465V95.7982H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 91.8402V95.7979H274.465V91.8402H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 114.841V117.078H267.521V114.841H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 110.138V112.374H267.521V110.138H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 103.154V105.391H267.521V103.154H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 98.6801V100.917L267.521 100.917V98.6801H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 94.1202V96.3571H267.521V94.1201L253.632 94.1202Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 60.1782V64.136L274.465 64.1359V60.1782H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 56.2202V60.178H274.465V56.2202H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 52.2626V56.2203H274.465V52.2626H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 48.3052V52.263H274.465V48.3052H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 44.3473V48.3051L274.465 48.3049V44.3472L253.632 44.3473Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 40.3892V44.347H274.465V40.3892H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 36.4316V40.3894L274.465 40.3892V36.4316H253.632Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 59.4325V61.6694H267.521V59.4325H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 54.7289V56.9659H267.521V54.7289H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 47.7455V49.9826L267.521 49.9824V47.7455H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 43.2719V45.5088H267.521V43.2718L253.632 43.2719Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M253.632 38.7115V40.9485H267.521V38.7115H253.632Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.111963
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.926 18.7144L274.928 205.692L276.047 205.692L276.046 18.7144L274.926 18.7144Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.995 19.3848L251.995 202.786L255.017 202.786L255.017 19.3848L251.995 19.3848Z",
    fill: "#FF4D5A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.362 202.72L252.362 209.668L277.247 209.668L277.247 202.72L252.362 202.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.362 11.9366L252.362 18.8848L277.247 18.8847L277.247 11.9366L252.362 11.9366Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7059 214.878H251.193H252.416V5.31753C238.311 5.72485 204.917 6.29507 184.176 5.31753C158.248 4.09561 139.17 31.3448 120.581 49.5515C105.71 64.1169 69.7873 72.1573 53.685 74.3567C37.1749 76.7598 4.37512 94.6897 5.25566 147.184C6.1362 199.677 48.5893 214.187 69.7059 214.878Z",
    fill: "white"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3245 169.806V196.453H91.6216V175.136L81.1532 193.066H79.8207L69.3523 175.25V196.453H66.6494V169.806H68.9716L80.544 189.563L92.0023 169.806H94.3245ZM120.48 176.43V196.453H117.891V192.799C117.181 194.018 116.203 194.968 114.96 195.655C113.716 196.313 112.295 196.643 110.696 196.643C108.082 196.643 106.014 195.92 104.491 194.473C102.994 193.002 102.245 190.858 102.245 188.041V176.43H104.948V187.774C104.948 189.881 105.469 191.48 106.509 192.571C107.55 193.662 109.034 194.208 110.963 194.208C113.069 194.208 114.732 193.573 115.95 192.304C117.168 191.01 117.777 189.221 117.777 186.937V176.43H120.48ZM133.417 196.643C131.793 196.643 130.232 196.415 128.735 195.958C127.263 195.477 126.108 194.879 125.271 194.17L126.489 192.038C127.326 192.698 128.379 193.244 129.648 193.675C130.917 194.081 132.237 194.284 133.607 194.284C135.435 194.284 136.78 194.005 137.643 193.447C138.531 192.863 138.975 192.051 138.975 191.01C138.975 190.274 138.734 189.703 138.252 189.297C137.77 188.865 137.16 188.548 136.424 188.345C135.688 188.117 134.711 187.901 133.493 187.698C131.869 187.393 130.562 187.089 129.572 186.784C128.582 186.454 127.732 185.909 127.022 185.147C126.336 184.386 125.994 183.333 125.994 181.988C125.994 180.312 126.692 178.942 128.088 177.877C129.483 176.811 131.425 176.278 133.912 176.278C135.206 176.278 136.501 176.456 137.795 176.811C139.089 177.141 140.155 177.585 140.993 178.144L139.813 180.312C138.163 179.17 136.196 178.599 133.912 178.599C132.186 178.599 130.879 178.905 129.991 179.513C129.128 180.122 128.697 180.923 128.697 181.911C128.697 182.673 128.938 183.282 129.42 183.739C129.928 184.196 130.549 184.538 131.285 184.767C132.021 184.97 133.036 185.185 134.331 185.414C135.929 185.718 137.211 186.023 138.176 186.328C139.14 186.632 139.965 187.152 140.65 187.888C141.335 188.624 141.678 189.64 141.678 190.934C141.678 192.685 140.942 194.081 139.47 195.122C138.023 196.137 136.006 196.643 133.417 196.643ZM146.675 176.43H149.378V196.453H146.675V176.43ZM148.045 172.052C147.487 172.052 147.017 171.862 146.637 171.481C146.256 171.101 146.066 170.644 146.066 170.111C146.066 169.603 146.256 169.159 146.637 168.778C147.017 168.398 147.487 168.207 148.045 168.207C148.602 168.207 149.073 168.398 149.454 168.778C149.833 169.134 150.025 169.565 150.025 170.073C150.025 170.631 149.833 171.101 149.454 171.481C149.073 171.862 148.602 172.052 148.045 172.052ZM165.197 196.643C163.217 196.643 161.44 196.212 159.867 195.35C158.319 194.487 157.1 193.282 156.212 191.733C155.324 190.16 154.88 188.396 154.88 186.442C154.88 184.487 155.324 182.736 156.212 181.188C157.1 179.64 158.319 178.434 159.867 177.571C161.44 176.71 163.217 176.278 165.197 176.278C166.921 176.278 168.457 176.621 169.802 177.306C171.173 177.966 172.251 178.942 173.038 180.236L171.02 181.607C170.36 180.617 169.523 179.881 168.508 179.4C167.492 178.891 166.388 178.637 165.197 178.637C163.75 178.637 162.443 178.967 161.275 179.627C160.133 180.262 159.232 181.175 158.572 182.368C157.938 183.561 157.621 184.919 157.621 186.442C157.621 187.99 157.938 189.36 158.572 190.553C159.232 191.721 160.133 192.634 161.275 193.294C162.443 193.929 163.75 194.246 165.197 194.246C166.388 194.246 167.492 194.005 168.508 193.523C169.523 193.04 170.36 192.304 171.02 191.315L173.038 192.685C172.251 193.98 171.173 194.968 169.802 195.655C168.433 196.313 166.896 196.643 165.197 196.643ZM178.347 176.43H181.05V196.453H178.347V176.43ZM179.718 172.052C179.16 172.052 178.69 171.862 178.309 171.481C177.929 171.101 177.738 170.644 177.738 170.111C177.738 169.603 177.929 169.159 178.309 168.778C178.69 168.398 179.16 168.207 179.718 168.207C180.276 168.207 180.746 168.398 181.127 168.778C181.507 169.134 181.698 169.565 181.698 170.073C181.698 170.631 181.507 171.101 181.127 171.481C180.746 171.862 180.276 172.052 179.718 172.052ZM195.575 176.278C198.189 176.278 200.194 176.938 201.59 178.258C202.986 179.551 203.684 181.48 203.684 184.043V196.453H201.095V193.332C200.486 194.373 199.585 195.185 198.392 195.769C197.225 196.353 195.829 196.643 194.205 196.643C191.971 196.643 190.196 196.11 188.876 195.044C187.556 193.98 186.896 192.571 186.896 190.82C186.896 189.119 187.504 187.749 188.724 186.708C189.966 185.668 191.933 185.147 194.623 185.147H200.981V183.929C200.981 182.203 200.499 180.896 199.534 180.008C198.57 179.094 197.161 178.637 195.309 178.637C194.04 178.637 192.821 178.853 191.654 179.286C190.486 179.692 189.484 180.262 188.646 180.998L187.429 178.98C188.443 178.117 189.663 177.458 191.083 177C192.504 176.519 194.002 176.278 195.575 176.278ZM194.623 194.511C196.146 194.511 197.453 194.17 198.545 193.485C199.636 192.774 200.448 191.759 200.981 190.439V187.165H194.7C191.273 187.165 189.56 188.358 189.56 190.744C189.56 191.911 190.004 192.837 190.894 193.523C191.781 194.183 193.024 194.511 194.623 194.511ZM221.227 176.278C223.739 176.278 225.731 177.014 227.203 178.485C228.701 179.933 229.45 182.051 229.45 184.843V196.453H226.747V185.109C226.747 183.028 226.226 181.442 225.186 180.352C224.145 179.259 222.66 178.715 220.732 178.715C218.574 178.715 216.861 179.362 215.592 180.655C214.35 181.924 213.728 183.688 213.728 185.947V196.453H211.025V176.43H213.614V180.122C214.35 178.905 215.365 177.966 216.658 177.306C217.978 176.621 219.501 176.278 221.227 176.278Z",
    fill: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 270.448,
    y: 10.877,
    width: 10.0776,
    height: 195.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.35889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 247.517,
    y: 9.69733,
    width: 34.2086,
    height: 206.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.23926
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 247.517,
    y: 19.3848,
    width: 11.9786,
    height: 192.358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.47852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 0.759762,
    y: 0.799298,
    width: 256.135,
    height: 218.558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiano);
export default __webpack_public_path__ + "static/media/piano.f592378de977a4eda4e1b340bd64c08c.svg";
export { ForwardRef as ReactComponent };